import { Card, CardContent } from "./ui/card";

/**
 * Friendly empty-state block for list pages. `actions` is rendered below the copy
 * (typically one or two CTA buttons).
 */
export function EmptyState({ icon: Icon, title, description, actions, testId }) {
  return (
    <Card className="surface-card border-dashed border-[#CBD5E1]" data-testid={testId || "empty-state"}>
      <CardContent className="p-10 text-center flex flex-col items-center">
        {Icon && (
          <div className="w-14 h-14 rounded-2xl bg-[#0EA5E9]/10 flex items-center justify-center mb-4">
            <Icon size={28} weight="duotone" color="#0EA5E9" />
          </div>
        )}
        <div className="font-display text-lg font-semibold text-[#0F172A]">{title}</div>
        {description && <p className="text-sm text-[#475569] mt-1.5 max-w-md">{description}</p>}
        {actions && <div className="mt-5 flex items-center justify-center gap-2 flex-wrap">{actions}</div>}
      </CardContent>
    </Card>
  );
}

export default EmptyState;
